import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { googleLogin } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { signIn } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const data = await googleLogin(sessionId);
        signIn(data.access_token, data.user);
        navigate(data.user.role === "admin" ? "/admin" : "/portal");
      } catch (e) {
        console.error(e);
        navigate("/login");
      }
    })();
  }, [navigate, signIn]);

  return (
    <div className="lm-font min-h-screen lm-hero-bg flex flex-col items-center justify-center">
      <Logo size={56} />
      <p className="mt-6 text-[#11151C]/70">Signing you in...</p>
    </div>
  );
}
